import $ from 'jquery';

// this file is meant to handle all the events for all the objects
const eventsHandler = function () {
    var $body = $('body');
    // click event on the logout button when attr eq value
    var classname = document.getElementsByClassName("js-lgc-logout");

    var unauthButton = function() {
        var callbackUrl = this.getAttribute('data-cms-callback-url');
        logout(function(){
            window.sessionStorage.removeItem("alerting_counter");
            window.location.replace(callbackUrl);
        });
    };

    for (var i = 0; i < classname.length; i++) {
        classname[i].addEventListener('click', unauthButton, false);
    }

    // click event on the back button
    $body.on( "click" ,"button.dcw_header-title_back, button.dcw_submenu-auth_back-btn",function() {
        window.history.back();
    });

    // click event on the open mobile contextual menu
    $body.on( "click" ,".dcw_contextual-menu-mobile_btn",function() {
        $(this).next(".dcw_contextual-menu-mobile_pane").addClass("is-open");
        $("main").addClass("is-blurred");
        $("body").css("overflow", "hidden");
    });

    // click event on the close mobile contextual menu
    $body.on( "click" ,".dcw_contextual-menu-mobile_close",function() {
        $("body").css("overflow", "");
        $("main").removeClass("is-blurred");
        $(this).parent().removeClass("is-open");
    });

    // click event on the close mobile contextual menu
    // A VERIFIER AVEC DAMIEN
    $body.on( "click" ,".dcw_contextual-menu-mobile_link",function() {
        $("body").css("overflow", "");
        $("main").removeClass("is-blurred");
        $(this).closest('.dcw_contextual-menu-mobile_pane').removeClass("is-open");
    });
};


export {eventsHandler};


// WEBPACK FOOTER //
// ./src/js/cms/commons/events-handler.js